import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M28.719 3.333H3.284A8.16 8.16 0 0 1 6.343 1.23C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.691 1.263a8.15 8.15 0 0 1 3.028 2.07M3.284 28.667h25.432a8.16 8.16 0 0 1-3.059 2.103C23.567 31.6 19.75 31.967 16 32c-3.75-.034-7.567-.432-9.658-1.23a8.16 8.16 0 0 1-3.058-2.103",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M6.008 10.925Q6 11.128 6 11.333c0 5.523 4.477 10 10 10s10-4.477 10-10q0-.205-.008-.408c.436 1.164.675 2.425.675 3.742 0 5.89-4.776 10.666-10.667 10.666-5.89 0-10.666-4.775-10.666-10.666 0-1.317.238-2.578.674-3.742",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m16 14.2-3.135 2.2 1.106-3.688-3.043-2.327 3.818-.079L16 6.666l1.254 3.64 3.818.079-3.043 2.327 1.106 3.688z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagMrt = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagMrt_default = SvgFlagMrt;

export { FlagMrt_default as default };
